export default { get, post }

function get() {
  throw new Error('Unimplemented')
}

class XHRError extends Error {
  status: number
  contentType: string | null
  responseText: string

  constructor(xhr: XMLHttpRequest) {
    super('HTTP status ' + xhr.status)
    this.status = xhr.status
    this.contentType = xhr.getResponseHeader('Content-Type')
    this.responseText = xhr.responseText
  }
}

// Expects a URL (absolute or relative) and JSON object.
// Returns a Promise. Accepts with JSON object response, rejects with status code.
function post(path: string, body: Record<string, any>) {
  return new Promise<Record<string, any>>((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', path)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.setRequestHeader('X-CSRF', 'csrf')
    xhr.onload = () => {
      const { status, responseText } = xhr
      if (status >= 200 && status < 300) {
        resolve(JSON.parse(responseText) as Record<string, any>)
      } else {
        reject(new XHRError(xhr))
      }
    }
    xhr.onerror = () => reject(xhr.status)
    xhr.send(JSON.stringify(body))
  })
}
